import { FcCancel } from 'react-icons/fc';
import React from 'react';

export function CantWatchNow() {
  return (
    <div className={'flex-0 m-4 bg-gray-100 rounded-2xl p-4 flex items-center'}>
      <FcCancel size={32} className={'mr-4'} />

      <div>
        <h2 className={'font-bold text-lg'}>Can&apos;t Watch Now?</h2>
        <p className={'text-gray-700'}>
          Sign up to be notified of future events.
        </p>
      </div>
    </div>
  );
}
